<template>
    <div>
        <div class="row">   
            <div class="card-status-center">
                <card-status />
            </div>
        </div>
        <div class="row">
            <select class="form-control" name="queues" id="queueSelect" v-model="queueSelect">
                <option value="*">Todas as filas</option>
                <option v-for="q in queues" :key="q.id" :value="q.name">{{q.name}}</option>
            </select>
        </div>
        <div class="row">
            <div class="col-md-7">
                <div class="cards-container">
                    <card-realtime
                        v-for="op in filteredOperators"
                        :key="op.id"
                        :nome="op.nome" 
                        :id="op.id" 
                        :extension="op.extension_line"
                        :status="userStatus"
                        :connection="connection"
                        :userQueues="op.queues"
                        class="card"
                    ></card-realtime>
                </div>
            </div>

            <div class="col-md-5">
                <calls-queue :connection="connection"/>
                <total-calls :connection="connection"/>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import cardRealtime from './CardRealtime.vue'
import cardStatus from './CardStatus.vue'
import callsQueue from './CallsinQueue'
import totalCalls from './TotalCalls'
const isSSL = (location.hostname == 'localhost')? 'http': 'https';
const parsedTelefone = (process.env.MIX_TELEFONE === 'true');
const connection = (parsedTelefone) ? io.connect(`${isSSL}://${location.hostname}:3003/realtimeModule`) : {'on': function(){}, 'emit': function(){}};	

export default {
    components: {cardRealtime, cardStatus, callsQueue, totalCalls},
    data() {
        return {
            operators: [],
            connection: {},
            queueStatus: [],
            filteredOperators: [],
            queues: [],
            queueSelect: '*'
        }
    },
    methods: {
        groupQueues() {
            this.queueStatus = [];
        },
        allQueues(){
            return axios.get('/listQueue').then(({ data }) => {
                if(data && data.length > 0){
                    this.queues = data;
                }
            });
        }
    },
    created() {
        this.connection = connection;
        axios.get('/realtime/listUsersPhone').then(({ data }) => {
            this.operators = data;
            this.filteredOperators = data;
        });
        
        this.allQueues();
        this.userStatus = 'Deslogado'
    },
    mounted() {
        this.connection.emit('QueueStatus');
    },
    watch: {
        queueSelect() {
            if(this.queueSelect != '*'){
                this.filteredOperators = this.operators.filter(el => {
                    return el.queues.some(queue => {
                        return queue.name.includes(this.queueSelect);
                    });
                });
            } else {
                this.filteredOperators = this.operators;
            }
            this.connection.emit('QueueStatus');
        }
    }
}
</script>

<style scoped>
.card-status-center{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

#queueSelect{
    width: 200px !important
}

.card {
    max-width: 320px;
}

.cards-container {
    display: flex;
    min-width: 650px;
    max-height: 650px;
    flex-wrap: wrap;
    justify-content: space-around;
}

</style>